module.exports = __webpack_public_path__ + "static/media/play_icon_big.fb4317ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/recorded/play_icon_big.png
// module id = 2073
// module chunks = 6